import React from "react";
import * as s from "./index.module.scss";
import { Accordion } from "react-bootstrap";
import { IoChevronDownOutline } from "react-icons/io5";
import secondaryFont from "@/utils/secondaryFont";
import { PrismicRichText } from "@prismicio/react";
import { asText } from "@prismicio/helpers";

const FAQ = ({ slice, context }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: slice?.items?.map((q) => {
      return {
        "@type": "Question",
        name: q.question || "",
        acceptedAnswer: {
          "@type": "Answer",
          text: asText(q.answer) || "",
        },
      };
    }),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(schema),
        }}
      />
      <section
        className={`section-center ${s.faq} ${context?.faqWhiteBg ? s.white : ""}`}
      >
        <div className={s.faq_wrapper}>
          <h2 className="text-center title fw-bold">
            {slice?.primary?.title || "Frequently asked questions"}
          </h2>
          {slice?.primary?.description && (
            <div className={`text-center ${secondaryFont} title intro`}>
              <PrismicRichText field={slice?.primary?.description || []} />
            </div>
          )}
          <div>
            <Accordion>
              {slice?.items?.map(({ question, answer }, idx) => {
                return (
                  <Accordion.Item eventKey={idx} key={idx}>
                    <Accordion.Header
                      className={`${secondaryFont} sub-title d-flex gap-3`}
                      style={{ color: "red" }}
                    >
                      {question}{" "}
                      <span>
                        {" "}
                        <IoChevronDownOutline size="22px" />{" "}
                      </span>
                    </Accordion.Header>
                    <Accordion.Body className={`${secondaryFont} sub-title`}>
                      <PrismicRichText field={answer || []} />
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQ;
